// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8pkew","wrapper":"styles_wrapper__3CroI","input":"styles_input__1fW8Q","error":"styles_error__HEDo_","submitBtn":"styles_submitBtn__QOwsZ"};